<template>
  <v-row justify="center">
    <v-dialog v-model="value" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="blue rounded-0">
          <v-toolbar-title id="moduleAyarText">
            {{ $t("PANEL.MODULE.SETTINGS_DIALOG.TITLE") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog" class="mr-0">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div v-if="optionNavigation.length > 0">
          <v-tabs v-model="tab">
            <v-tab :key="key" v-for="(option, key) in optionNavigation" @click="setOption(option.sysname)">
              <v-icon left> mdi-tune-vertical-variant</v-icon>
              {{ option.name }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item :key="key" v-for="(inputs, key) in tabItems">
              <v-card flat>
                <v-card-text>
                  <v-col cols="12" lg="4" class="px-0">
                    <p class="text-body-2">{{ $t("PANEL.MODULE.SETTINGS_DIALOG.SUB_TEXT") }}</p>
                    <ListInputs :inputs="inputs" @input="inputData" />
                  </v-col>
                  <v-col cols="12" lg="4" class="px-0">
                    <v-btn color="blue" class="d-block ml-auto" dark @click="updateInputList">
                      <v-icon left>mdi-refresh</v-icon>
                      {{ $t("PANEL.MODULE.SETTINGS_DIALOG.SETTINGS_UPDATE_BTN") }}
                    </v-btn>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
        <div v-else class="d-flex justify-center align-center mt-10">
          <p class="title font-weight-regular grey--text">
            {{ $t("PANEL.MODULE.SETTINGS_DIALOG.SETTINGS_NOT_SET") }}
          </p>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import ListInputs from "@/components/Settings/SystemSettings/ListInputs.vue";

export default {
  name: "ModuleSettingsDialog",
  components: {
    ListInputs
  },
  props: {
    value: {
      type: Boolean
    },
    name: {
      type: String
    }
  },
  data() {
    return {
      tab: 0,
      tabStatus: false,
      tabItems: [],
      optionSysName: ""
    };
  },
  computed: {
    ...mapState({
      optionNavigation: state => state.Option.ModuleOptions.optionList,
      inputList: state => state.Option.ModuleOptions.inputList,
      apiLanguage: state => state.Language.apiLanguage
    })
  },
  methods: {
    /**
     * İlgili modüle ait input listesini getirir
     */
    getInputList(optionSysName) {
      this.$store
        .dispatch("Option/ModuleOptions/getInputList", {
          optionSysName,
          ...this.getType(),
          lang: this.apiLanguage
        })
        .then(() => {
          this.tabStatus = true;
          this.$set(this.tabItems, this.tab, this.inputList);
        });
    },
    currentInputs() {
      return this.tabItems[this.tab];
    },
    /**
     *  Ayar listesini güncelle
     */
    updateInputList() {
      const optionSysName = this.optionSysName,
        inputList = this.currentInputs();
      this.$store
        .dispatch("Option/ModuleOptions/updateInputList", {
          optionSysName,
          inputList,
          ...this.getType()
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("PANEL.MODULE.NOTIFY.SETTINGS_UPDATE_SUCCESS", { NAME: this.name }), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        });
    },
    setOption(optionSysName) {
      if (this.optionSysName !== optionSysName) {
        this.optionSysName = optionSysName;
        this.getInputList(optionSysName);
      }
    },
    inputData(data) {
      this.tabItems[this.tab] = data;
    },
    /**
     * Module Options için type belirtmesi yapar
     */
    getType() {
      let optionType = "Modules",
        optionName = this.name;
      return { optionType, optionName };
    },
    closeDialog() {
      this.$emit("input", false);
    }
  },

  created() {
    this.$store.commit("Option/ModuleOptions/setLang", this.apiLanguage);
  },

  watch: {
    name() {
      this.$store.dispatch("Option/ModuleOptions/getOptionList", { ...this.getType() }).then(res => {
        /**
         * Name değiştiği zaman panel tekrar açılmıştır
         * o zaman ilk ayarı otomatik olarak aktif et
         */
        if (res.status === 200 && res.data.length > 0) {
          this.setOption(res.data[0].sysname);
        }
      });
    }
  }
};
</script>

<style>
#moduleAyarText {
  font-size: 18px;
}
</style>
